import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider, getToken, AppCheck } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: process.env.GATSBY_FIREBASE_API_KEY,
  authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.GATSBY_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

let appCheck: AppCheck | undefined;

if (typeof window !== 'undefined' && process.env.GATSBY_FIREBASE_ENABLE_APPCHECK === 'true') {
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider(process.env.GATSBY_GOOGLE_CAPTCHA_SITE_KEY),
    isTokenAutoRefreshEnabled: true,
  });
}

export async function getAppCheckToken(forceRefresh = false): Promise<string | null> {
  if (!appCheck) return null;

  try {
    const tokenResult = await getToken(appCheck, forceRefresh);

    return tokenResult.token;
  } catch (error) {
    return null;
  }
}
